<template>
  <v-layout row wrap justify-center>
    <v-card class="shadow flex xs12 pa-0">
      <div
        class="
          py-1
          px-3
          secondary
          white--text
          font-weight-bold
          di-flex
          justify-center
          align-center
        "
      >
        <span class="py-1">{{ $t("exchange_income_report") }}</span>
        <v-spacer />
        <div>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn color="white" class="py-0 ma-0" flat dark v-on="on">
                <!-- <v-icon class="mx-2">more_vert</v-icon> -->
                <strong class="mt-1"> {{ selected_currency.name }} </strong>
              </v-btn>
            </template>

            <v-list>
              <v-list-tile
                :key="index"
                @click="currencyChanged(item)"
                v-for="(item, index) in currencies"
              >
                <v-list-tile-title>{{ item.name }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </div>
      </div>
      <v-card-text class="pt-3">
        <v-layout row wrap class="flex-row align-center justify-center">
          <!-- <v-checkbox
            singleLine
            hideDetails
            color="primary"
            @change="initData"
            v-model="filter_date"
            style="max-width: 24px"
          /> -->

          <v-date
            singleLine
            :clearable="true"
            :hideDetails="true"
            @input="initData"
            format="YYYY-MM-DD"
            v-model="start_date"
            value-type="YYYY-MM-DD"
            input_id="start_date_expo"
            :placeholder="$t('start_date')"
            :disabled="!filter_date && !loading"
            class="mx-2 flex xs12 md2 hide-details"
          />
          <v-date
            singleLine
            :hideDetails="true"
            @input="initData"
            v-model="end_date"
            format="YYYY-MM-DD"
            value-type="YYYY-MM-DD"
            input_id="end_date_expo"
            :placeholder="$t('end_date')"
            :disabled="!filter_date && !loading"
            class="mx-2 flex xs12 md2 hide-details"
          />
          <v-spacer />
          <v-text-field
            outline
            hide-details
            v-model="search"
            style="max-width: 420px"
            class="flex xs12 rounded"
            :placeholder="$t('search')"
            prepend-inner-icon="search"
          />
          <v-btn
            flat
            icon
            class="mx-0"
            @click="initData"
            :loading="loading"
            color="grey darken-2"
          >
            <v-icon>refresh</v-icon>
          </v-btn>
          <v-btn
            icon
            flat
            class="mx-0"
            color="grey darken-2"
            @click="printTable(false)"
          >
            <v-icon>print</v-icon>
          </v-btn>
          <v-btn
            flat
            icon
            class="mx-0"
            color="grey darken-2"
            @click="printTable(true)"
          >
            <v-icon>file_download</v-icon>
          </v-btn>
        </v-layout>

        <v-data-table
          ref="tbl"
          :items="items"
          :search="search"
          :loading="loading"
          :headers="headers"
          disable-initial-sort
          :rows-per-page-items="per_page"
        >
          <template slot="items" slot-scope="{ item }">
            <tr>
              <td>{{ item.number }}</td>
              <td>
                {{
                  item.sale_profit
                    | currency({ symbol: smbl(item.sale_currency_id) })
                }}
              </td>
              <td>
                {{
                  item.buy_profit
                    | currency({ symbol: smbl(item.buy_currency_id) })
                }}
              </td>
              <td>
                {{
                  item.base_profit
                    | currency({ symbol: smbl(base_currency_id) })
                }}
              </td>
              <td>{{ item.description }}</td>
              <td>{{ item.date | persianDateFilter(true) }}</td>
              <td>{{ item.date | persianDateFilter }}</td>
              <td>{{ item.time }}</td>
              <td
                :class="{
                  'red--text': item.debit < 0,
                  'activeColor--text': item.debit > 0,
                }"
              >
                <span>
                  {{
                    item.debit | currency({ symbol: smbl(base_currency_id) })
                  }}
                </span>
              </td>
              <td
                :class="{
                  'red--text': item.credit < 0,
                  'activeColor--text': item.credit > 0,
                }"
              >
                <span>
                  {{
                    item.credit | currency({ symbol: smbl(base_currency_id) })
                  }}
                </span>
              </td>
              <td
                :class="{
                  'red--text': item.balance < 0,
                  'activeColor--text': item.balance > 0,
                }"
              >
                {{
                  item.balance | currency({ symbol: smbl(base_currency_id) })
                }}
              </td>
            </tr>
          </template>
          <template slot="footer">
            <tr class="font-weight-bold">
              <td colspan="8">
                {{ $t("total") }}
              </td>
              <td>
                {{
                  summery.debit | currency({ symbol: smbl(base_currency_id) })
                }}
              </td>
              <td>
                {{
                  summery.credit | currency({ symbol: smbl(base_currency_id) })
                }}
              </td>
              <td colspan="2">
                {{
                  summery.balance | currency({ symbol: smbl(base_currency_id) })
                }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-layout>
</template>

<script>
import curjs from "currency.js";
import debounce from "@/plugins/vDebounce";
import { customersMixin } from "@/mixins/index.js";

let currentDate = new Date();
currentDate.setDate(currentDate.getDate() - 30);
export default {
  name: "ExposeReport",
  mixins: [customersMixin],
  props: {
    branch_id: { default: undefined },
    brnch_name: { default: "" },
  },
  data: () => ({
    search: "",
    items: [],
    dialog: false,
    editIndex: -1,
    loading: false,
    editDialog: false,
    selected_currency: {
      id: undefined,
      name: "ALl Currencies",
    },
    selected_type: {
      value: undefined,
      text: "All Types",
    },
    filter_date: true,
    start_date: currentDate.toLocaleDateString("en-ca"),
    end_date: new Date().toLocaleDateString("en-ca"),
    opening_balance: 0,
  }),

  computed: {
    types() {
      return [
        {
          value: undefined,
          text: "All Types",
        },
        {
          text: "Sale",
          value: "sale",
        },
        {
          text: "Buy",
          value: "buy",
        },
        {
          text: "F2F",
          value: "f2f",
        },
      ];
    },

    currencies() {
      let items = this.initialData.currencies;
      return [{ id: undefined, name: "ALl Currencies" }, ...items];
    },
    summery() {
      let credit = 0;
      let debit = 0;
      let balance = this.opening_balance;

      this.items.forEach((item) => {
        credit += item.credit;
        debit += item.debit;
        balance += item.base_profit;
      });
      return {
        credit,
        debit,
        balance,
        opening_balance: this.opening_balance,
      };
    },

    can() {
      return {
        add: this.userCan("add_exchanges"),
        view: this.userCan("view_exchanges"),
        edit: this.userCan("edit_exchanges"),
        delete: this.userCan("delete_exchanges"),
        any:
          this.userCan("edit_exchanges") ||
          this.userCan("view_exchanges") ||
          this.userCan("delete_exchanges"),
      };
    },

    headers: (vm) => {
      let items = [
        {
          value: "number",
          width: "30px",
          sortable: false,
          hidePrint: true,
          text: vm.$t("tr"),
        },
        {
          sortable: false,
          value: "sale_profit",
          text: vm.$t("sale_profit"),
          computed: (item) =>
            curjs(item.sale_profit).format({ symbol: "" }) +
            " " +
            vm.smbl(item.sale_currency_id),
        },
        {
          sortable: false,
          value: "buy_profit",
          text: vm.$t("buy_profit"),
          computed: (item) =>
            curjs(item.base_profit).format({ symbol: "" }) +
            " " +
            vm.smbl(item.buy_currency_id),
        },
        {
          sortable: false,
          value: "base_profit",
          text: vm.$t("profit"),
          computed: (item) =>
            curjs(item.base_profit).format({ symbol: "" }) + " USD",
        },
        {
          width: "400px",
          sortable: false,
          value: "description",
          text: vm.$t("description"),
        },
        {
          value: "date",
          width: "120px",
          sortable: false,
          text: vm.$t("persian_date"),
          computed: (item) => vm.persianDateFilter(item.date, true),
        },
        {
          value: "date",
          width: "120px",
          sortable: false,
          text: vm.$t("date"),
          computed: (item) => vm.persianDateFilter(item.date),
        },
        {
          value: "time",
          width: "120px",
          sortable: false,
          text: vm.$t("time"),
        },
        {
          value: "debit",
          sortable: false,
          text: vm.$t("debit"),
          computed: (item) => curjs(item.debit).format({ symbol: "" }) + " USD",
        },
        {
          value: "credit",
          sortable: false,
          text: vm.$t("credit"),
          computed: (item) =>
            curjs(item.credit).format({ symbol: "" }) + " USD",
        },
        {
          text: vm.$t("balance"),
          sortable: false,
          value: "balance",
          computed: (item) =>
            curjs(item.balance).format({ symbol: "" }) + " USD",
        },
      ];
      return items;
    },
  },
  methods: {
    initData() {
      this.loading = true;
      let { search, end_date, branch_id, start_date, filter_date } = this;
      let params = {
        search,
        end_date,
        branch_id,
        start_date,
        filter_date,
        type: this.selected_type.value,
        currency_id: this.selected_currency.id,
      };
      this.axios
        .get("reports?exchangeIncomes=true", { params })
        .then((resp) => {
          this.items = resp.data.data;
          this.opening_balance = resp.data.opening_balance;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    currencyChanged(item) {
      this.selected_currency = item;
      this.initData();
    },
    typeChanged(item) {
      this.selected_type = item;
      this.initData();
    },
    printTable(excel) {
      let items = this.$refs.tbl.filteredItems;
      items.push({
        description: this.$t("total"),
        credit: this.summery.credit,
        debit: this.summery.debit,
        balance: this.summery.balance,
      });
      for (let currency in this.summery.currencies) {
        items.push({
          sale_currency_id: currency,
          amount: this.summery.amount[currency],
          exchanged_amount: this.summery.amount[currency],
          exposed_amount: this.summery.exposed_amount[currency],
        });
      }
      // items.puhs()
      let data = {
        items,
        landscape:true,
        brnch_name: this.brnch_name,
        headers: this.headers.filter((x) => !x.hidePrint),
        title: `${this.$t("exchange_income_report")} ${this.$t("from")} ${
          this.start_date
        } ${this.$t("to")} ${this.end_date}`,
      };

      if (excel) return this.xl_tables(data, "exchanges", this.LONG_APP_NAME);
      this.$store.commit("ReportsModule/setTableData", data);
      this.$router.push("/print");
    },
  },

  created() {
    this.initData();
  },

  watch: {
    branch_id: {
      handler() {
        this.initData();
      },
      deep: true,
    },
    search: debounce(function (newVal) {
      this.initData(newVal);
    }, 1000),
  },
};
</script>
